<template>
<div>
  <div class="full" style="display: flex; flex-direction: column;">
    <div class="container home-container" style="flex: 1 auto">
      <div class="header-container">
        <div class="logo-container">
          <img class="logo" src="~@/assets/imgs/logo-weis.svg" />
        </div>
      </div>
      <div class="slogan-container">
        <img class="slogan-logo" src="~@/assets/imgs/welcome-to-real-home.svg" />
      </div>
      <div class="start">
          <b-button @click="onClickButton()" size="lg" variant="secondary">Jetzt starten</b-button>
      </div>
    </div>
  </div>
  <!-- <div class="disclaimer">
    <p>Platz für Disclaimer: Die Aktion richtet sich nur an volljährige Raucher mit gemeldetem Wohnsitz in Deutschland…Teilnahmeschluss für die Aktion ist der …. Pro Person ist die Teilnahme nur einmal möglich. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna Excepteur sint</p>
  </div> -->
</div>
</template>

<script>
export default {
  name: "Home",
  methods: {
    onClickButton () {
      this.$emit('start')
    }
  }
}
</script>
<style lang="scss" scoped>
.disclaimer {
  p {
    width: 666px;
    margin-left: auto;
    margin-right: auto;
    font-size: 12px;
    color: #939393;
    font-family: Helvetica;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
    opacity: 0.8;
  }
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: white;
}
.full {
  height: 100vh;
  max-height: 100vh;
  margin-left: auto;
  margin-right: auto;
  background-image: url("~@/assets/imgs/home-background.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.text-container {
  margin-top: auto;
  position: absolute;
  bottom: 0;
  white-space: nowrap;
  padding-left: 13px;
}
.slogan-container {
  display: flex;
  margin-top: 282px;
  padding: 0 0 0 40px;

  img {
    width: 100%;
  }
}
.button-wrapper {
  padding-top: 90px
}
.start {
  text-align: center;
  margin-top: 90px;
}
p {
  margin: 0;
  padding: 0;
  font-size: 31px;
}
.header-container {
  display: flex;

  .logo-container {
    padding-right: 42px;
    padding-bottom: 0px;
    margin-top: 32px;
  }
}

.home-container {
  padding-left: 0;
  padding-right: 0;
  max-width: 740px;
}
</style>
